import styled from '@emotion/styled'
import { Colors } from '~/assets/style/colors'
import { Sizes } from '~/assets/style/tokens'
import { IconWithTooltip } from '~/components/IconWithTooltip'
import { ExtraCatalogItemHeaderItem } from '~/feature-components/ModuleHeader'
import { isPbjsVersionBelowRequired } from '~/utils/semver'

const MinVersionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const usePbjsVersionHeaderItems = (
  pbjsMinRequiredVersion: string | undefined,
  scopePbjsVersion: string | undefined,
  integrationType: 'bidder' | 'module' = 'bidder'
): ExtraCatalogItemHeaderItem[] => {
  if (!pbjsMinRequiredVersion) {
    return []
  }

  const isVersionBelowRequired = isPbjsVersionBelowRequired(scopePbjsVersion, pbjsMinRequiredVersion)

  return [
    {
      label: 'Prebid.js min version',
      value: (
        <MinVersionWrapper>
          {isVersionBelowRequired && (
            <IconWithTooltip
              name="warning"
              width={Sizes[16]}
              fill={Colors.Warning}
              title={`This ${integrationType} requires Prebid.js ${pbjsMinRequiredVersion} or higher. Your scope is currently using ${scopePbjsVersion}.`}
            />
          )}
          {pbjsMinRequiredVersion}
        </MinVersionWrapper>
      ),
    },
  ]
}
